export function CATCH_ASYNC(p) {
    p.catch((e) => {
        console.error("CATCH_ASYNC ", e);
    });
    return p;
}
